import { useState, Suspense, lazy } from 'react';
import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import HeaderB from './components/headerb/headerb';
import MyConnections from './components/connections/connections';
import Sidebar from './components/sidebar/Sidebar';
import PageViewTracker from './components/analytics/PageViewTracker';

// Lazy load all pages for code splitting
const HomePage = lazy(() => import('./pages/home/home'));
const PageEvents = lazy(() => import('./pages/esemenyek/pageEvens'));
const Teszt = lazy(() => import('./pages/pagetest/pageTest'));
const PageExercisse3Main = lazy(() => import('./pages/exercise/pageExercise'));
const PageSportAbility = lazy(() => import('./pages/sportability/pageSportAbility'));
const PageProperty = lazy(() => import('./pages/property/pageProperty'));
const PageOrganisation = lazy(() => import('./pages/organisation/pageOrganisation'));
const PagePerson = lazy(() => import('./pages/person/pagePerson'));
const PageTrainingGroup = lazy(() => import('./pages/traininggroup/pageTrainingGroup'));
const PageTrainingHead = lazy(() => import('./pages/traininghead/pageTrainingHead'));
const PageResults = lazy(() => import('./pages/results/pageResults'));
const PageAllResult = lazy(() => import('./pages/allresult/pageAllResult'));
const PagePaymentForm = lazy(() => import('./pages/paymentform/pagePaymentForm'));
const PageDashboard = lazy(() => import('./pages/dashboard/pageDashboard'));
const PagePermissions = lazy(() => import('./pages/permissions/pagePermissions'));
const PageTaskWork = lazy(() => import('./pages/taskwork/pageTaskWork'));
const PageEventsAdmin = lazy(() => import('./pages/events/pageEvents'));
const PageTrainingPlan = lazy(() => import('./pages/trainingplan/pageTrainingPlan'));
const PageTrainingPlanEdit = lazy(() => import('./pages/trainingplan/pageTrainingPlanEdit'));
const PageSessionTemplates = lazy(() => import('./pages/trainingplan/pageSessionTemplates'));
const PagePrintSessionPlan = lazy(() => import('./pages/print/pagePrintSessionPlan'));
const PageStatistics = lazy(() => import('./pages/statistics/pageStatistics'));
const PageTudasBazis = lazy(() => import('./pages/tudasbazis/pageTudasBazis'));
const PageTudasBazisArticle = lazy(() => import('./pages/tudasbazis/pageTudasBazisArticle'));

// Loading fallback component
const PageLoader = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#aaa'
    }}>
        <span>Betöltés...</span>
    </div>
);

function AppContent() {
    const [language] = useState('hu');
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="App">
            <PageViewTracker />
            <header className="App-header">
                <HeaderB language={language} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
                <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                <div className='App-body'>
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            <Route path='/' element={<HomePage />} />
                            <Route path='/home' element={<HomePage />} />
                            <Route path='/esemenyek' element={<PageEvents language={language} />} />
                            <Route path='/tudasbazis' element={<PageTudasBazis />} />
                            <Route path='/tudasbazis/:slug' element={<PageTudasBazisArticle />} />
                            <Route path='/tgroups' element={<PageTrainingGroup language={language} />} />
                            <Route path='/exercise' element={<PageExercisse3Main language={language} />} />
                            <Route path='/organisations' element={<PageOrganisation language={language} />} />
                            <Route path='/persons' element={<PagePerson language={language} />} />
                            <Route path='/abilities' element={<PageSportAbility language={language} />} />
                            <Route path='/properties' element={<PageProperty language={language} />} />
                            <Route path='/traininghead' element={<PageTrainingHead language={language} />} />
                            <Route path='/results' element={<PageResults language={language} />} />
                            <Route path='/allresults' element={<PageAllResult language={language} />} />
                            <Route path='/paymentforms' element={<PagePaymentForm language={language} />} />
                            <Route path='/dashboard' element={<PageDashboard language={language} />} />
                            <Route path='/permissions' element={<PagePermissions language={language} />} />
                            <Route path='/taskwork' element={<PageTaskWork language={language} />} />
                            <Route path='/events-admin' element={<PageEventsAdmin language={language} />} />
                            <Route path='/trainingplan' element={<PageTrainingPlan language={language} />} />
                            <Route path='/trainingplan/:id' element={<PageTrainingPlanEdit language={language} />} />
                            <Route path='/print/session-plan' element={<PagePrintSessionPlan />} />
                            <Route path='/session-templates' element={<PageSessionTemplates />} />
                            <Route path='/statistics' element={<PageStatistics language={language} />} />
                            <Route path='/teszt' element={<Teszt language={language} />} />
                        </Routes>
                    </Suspense>
                </div>
                <MyConnections />
            </header>
        </div>
    );
}

function App() {
    const [language] = useState('hu');

    return (
        <HelmetProvider>
            <BrowserRouter>
                <ThemeProvider>
                    <AuthProvider language={language}>
                        <AppContent />
                        <Toaster />
                    </AuthProvider>
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;

